import React, { useState, useEffect } from "react"
import { navigate } from "gatsby"
import axios from "axios"
import Logo from "../../images/favicon.png"

import Nav from "../nav"
import ApplicationForm from "./ApplicationForm"

let axiosConfig = {
  headers: {
    "Access-Control-Allow-Origin": "*",
    api_key: process.env.SPARKLE_CAREERS,
  },
}

const Apply = (props) => {
  const [job, setJob] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState("")
  const getJobs = () => {
    axios({
      method: "get",
      url: `${process.env.GATSBY_SPARKLE_LOCAL_BASE_URL}/api/v1/career/${props.id}`,
      axiosConfig,
    })
      .then((response) => {
        if (response.data.success == false) {
          setError(response.data.message)
          navigate(`/careers`)
        } else {
          setJob(response.data)
          setLoading(false)
        }
      })
      .catch((error) => {
        console.error(error)
      })
  }

  useEffect(() => {
    getJobs()
  }, [])

  return (
    <>
      <div className="job-description pb-lg-5">
        <div className="nav-wrapper bg__sparkle--black">
          <div className="container">
            <Nav />
          </div>
        </div>
        <div className="container py-lg-5">
          <div className="row justify-content-center">
            {loading ? (
              <div className="text-center my-5 py-5">
                <div className="loader simple-circle mx-auto">
                  <img src={Logo} className="img-fluid" alt="sparkle logo" />
                </div>
              </div>
            ) : (
              <div className="col-lg-5 text-center">
                <h1 className="my-3 text-white sparkle--mont__900">
                 {Object.values(job).length > 0 && job.name}
                </h1>
                <p className="text-white mb-5">
                  {" "}
                  {
                    job.department_name}
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
      {loading ? (
        <div className="text-center my-5 py-5">
          {/* <div className="loader simple-circle mx-auto">
            <img src={Logo} className="img-fluid" alt="sparkle logo" />
          </div> */}
        </div>
      ) : (
        <>
          <ApplicationForm id={props.id} />
        </>
      )}

    </>
  )
}

export default Apply
